module.exports = __webpack_public_path__ + "img/pro_feature_video_chat.8719822.png";